module.exports = __webpack_public_path__ + "static/media/dataPointLogo.9353c09d.svg";